// extracted by mini-css-extract-plugin
export var blue = "br_fx";
export var button = "br_cb";
export var label = "br_cX";
export var orange = "br_fy";
export var white = "br_fz";